var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-listagem" },
    [
      _c(
        "el-row",
        [
          _c(
            "div",
            { staticClass: "container-pesquisa" },
            [
              _c("p", { staticClass: "titulo" }, [
                _vm._v("Pesquisa de demandas")
              ]),
              _c("pesquisa-avancada-demandas-relatorio", {
                attrs: { painel: _vm.painel, filtro: _vm.pesquisaAvancada }
              }),
              _c(
                "div",
                { staticClass: "button-pesquisa" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.resetPesquisa }
                    },
                    [_vm._v("Limpar")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.pesquisar }
                    },
                    [
                      _c("i", { staticClass: "fal fa-search iconColor" }),
                      _vm._v("  Pesquisar")
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("app-divider-refresh-button", {
            attrs: {
              label: "Listagem de demandas",
              hasButton: true,
              content: "Atualizar cadastros"
            },
            on: { click: _vm.getDemandas }
          }),
          _vm.modal
            ? _c("modal-visualizar-demanda", {
                attrs: { idDemanda: _vm.idDemanda },
                on: {
                  closeModal: _vm.closeModal,
                  callbackSucesso: _vm.callbackModal
                }
              })
            : _vm._e(),
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: { data: _vm.painel.demandas, size: "medium" },
              on: { "sort-change": _vm.sortChanged }
            },
            [
              _c("template", { slot: "empty" }, [_vm._v("Não há registros.")]),
              _c("el-table-column", {
                attrs: {
                  prop: "numeroDemanda",
                  label: "Nº",
                  width: "100",
                  formatter: _vm.Utils.formatEmptyRowNA,
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nome",
                  label: "Nome da demanda",
                  width: "auto",
                  formatter: _vm.Utils.formatEmptyRowNA,
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "painel.nome",
                  label: "Painel",
                  width: "auto",
                  formatter: _vm.Utils.formatEmptyRowNA,
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "estadoDemanda.nome",
                  label: "Estado",
                  width: "auto",
                  formatter: _vm.Utils.formatEmptyRowNA,
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "dataEntrega",
                  label: "Data de entrega",
                  width: "auto"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.dataEntregaJaPassou
                                ? "danger"
                                : scope.row.demandaAVencer
                                ? "warning"
                                : "success",
                              effect: "dark"
                            }
                          },
                          [_vm._v(_vm._s(scope.row.dataEntrega))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "prioridade.nome",
                  label: "Prioridade",
                  width: "auto",
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.prioridade
                          ? _c(
                              "el-tag",
                              {
                                style: {
                                  "background-color":
                                    scope.row.prioridade.codigo,
                                  color: "white",
                                  border: "none"
                                }
                              },
                              [_vm._v(_vm._s(scope.row.prioridade.nome))]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(_vm.Utils.formatEmptyRowNA()))
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "Responsável", width: "auto", minWidth: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.responsaveis &&
                        scope.row.responsaveis.length > 0
                          ? _c("avatar-list", {
                              attrs: {
                                data: scope.row.responsaveis,
                                label: "pessoa.nomeRazaoSocial"
                              }
                            })
                          : _c("span", [
                              _vm._v(_vm._s(_vm.Utils.formatEmptyRowNA()))
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", width: "auto" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("button-acoes", {
                          attrs: { acoes: _vm.botoesAcao(scope.row) }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            2
          ),
          _vm.showTotalListagem
            ? _c("div", { staticClass: "contador-total" }, [
                _c("span", [
                  _vm._v("Total de registros: " + _vm._s(_vm.totalRegistros))
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-442c6e34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-442c6e34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/ListagemDemandasRelatorio.vue
// module id = null
// module chunks = 